const messages = {
  name: 'Saldo de Creditos |||| Saldos de Creditos',
  fields: {
    costCenter: 'Centro de Coste',
    costCenterName: 'Centro de Coste',
    availableCredits: 'Creditos Disponibles',
    reservedCredits: 'Creditos Reservados',
    blocked: 'Bloqueado',
    amount: 'Cantidad de Creditos',
    newBalance: 'Nuevo saldo disponible',
  },
  columns: {
    actions: 'Acciones',
    status: 'Estado',
  },
  filters: {
    costCenterName: 'Centro de Coste',
  },
  status: {
    active: 'Activo',
    blocked: 'Bloqueado',
  },
  actions: {
    creditPurchase: 'Comprar Creditos',
    topUp: 'Recargar',
    adjust: 'Ajustar saldo',
    block: 'Bloquear',
    unblock: 'Desbloquear',
  },
  dialog: {
    purchaseTitle: 'Compra de Creditos',
    topUpTitle: 'Recargar Creditos',
    adjustTitle: 'Ajustar saldo',
    noEligibleCostCenters: 'Todos los centros de coste ya tienen saldo. Usa Recargar (menu ...) en una fila para anadir creditos.',
  },
  validation: {
    costCenterRequired: 'El Centro de Coste es obligatorio',
    amountRequired: 'La Cantidad de Creditos es obligatoria',
    amountMin: 'La cantidad debe ser al menos 1',
  },
  notifications: {
    purchaseSucceeded: 'Creditos anadidos correctamente',
    purchaseFailed: 'Error al anadir creditos',
    blockSucceeded: 'Saldo bloqueado',
    blockFailed: 'Error al bloquear el saldo',
    unblockSucceeded: 'Saldo desbloqueado',
    unblockFailed: 'Error al desbloquear el saldo',
    loadCostCentersFailed: 'Error al cargar los centros de coste',
  },
};

export default messages;
